module.exports = {
  title: 'Image',
  context: {
    src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_1200x700_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140914',
    alt: 'image alt',
    lazy: false,
    class: 'width--full',
    width: '1200',
    height: '700'
  },
  variants: [
    {
      name: 'Image with caption',
      context: {
        src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_1200x700_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140914',
        alt: 'image alt',
        lazy: false,
        class: 'width--full',
        caption: 'This is image with caption.',
        width: '1200',
        height: '700'
      }
    },
    {
      name: 'Image with srcSet',
      context: {
        src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_1200x700_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140914',
        srcSet: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_500x292_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140911 500w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_700x409_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140912 700w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_900x525_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140913 900w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_1200x700_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140914 1200w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_1600x934_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140916 1600w',
        alt: 'image alt',
        lazy: false,
        class: 'width--full',
        width: '1200',
        height: '700'
      }
    },
    {
      name: 'Image with lazy',
      context: {
        src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_1200x700_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140914',
        srcSet: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_500x292_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140911 500w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_700x409_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140912 700w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_900x525_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140913 900w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_1200x700_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140914 1200w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_1600x934_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140916 1600w',
        alt: 'image alt',
        lazy: true,
        class: 'width--full',
        width: '1200',
        height: '700'
      }
    },
    {
      name: 'Image Medium Width',
      context: {
        src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/cooking.jpg?mtime=20210623075136&focal=none',
        alt: 'image alt',
        lazy: false,
        class: 'width--medium',
        width: '800',
        height: '500'
      }
    }
  ]
}
